module.exports = __webpack_public_path__ + "Alex2-a340898e.png";